<template>
  <button type="button" class="bigButton" @click.prevent="onClick">
    <img v-if="iconSrc" :src="iconSrc" :class="`icon-${icon}`" aria-hidden="true" />
    {{ text }}
  </button>
</template>

<script>

export default {
  name: 'BigButton',
  props: ['action', 'text', 'icon'],
  computed: {
    iconSrc() {
      if(this.icon == 'play') {
        return "/static/images/icon-play-000000.svg"
      } else if (this.icon == 'pause') {
        return "/static/images/icon-pause-000000.svg"
      } else {
        return ""
      }
    }
  },
  methods: {
    onClick () {
      if (typeof this.action == 'function') {
        this.action();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/variables.scss';

  button {
    background: $light-green;
    @include font-family-standard-bold;
    font-size: 18px;
    height: 45px;
    width: 100%;
    border-radius: 45px;
    border-width: 0;
    padding: 0 15px;
    transition: background-color $fastTransitionDuration;
    white-space: nowrap;
    text-align: center;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

    &:hover {
      // background: lighten($blue, 5%);
      cursor: pointer;
    }
  }
  .icon-play{
    margin-right: 5px;
  }
  .icon-pause{
    margin-right: 5px;
    margin-bottom: -3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BigButton.vue